import { fetch } from "./fetch";
import { api_url } from "./urls";

let LOGGER_ERROR_LIMIT = 10000;
let log_error_counter = 0;
const sentErrors = {};

export const event = (logLevel, message, context, alwaysLog) => {
  if (!alwaysLog) {
    if (!sentErrors[message]) {
      sentErrors[message] = logLevel;
    } else {
      return;
    }
  }

  return fetch({
    url: `${api_url}/logger/${logLevel}`,
    method: "POST",
    body: {
      message: message,
      context: Object.assign({}, context, {
        user_agent: window.navigator.userAgent,
        frontend_ver: "next",
        frontend_uri: window.location.href,
      }),
    },
  }).catch(() => null);
};

export const error = (error, context, alwaysLog) => {
  if (log_error_counter < LOGGER_ERROR_LIMIT) {
    if (typeof error !== "string" && typeof error !== "object") {
      error = "Unknown error";
    }
    if (typeof context !== "object") {
      context = {};
    }
    event("error", typeof error === "object" ? error?.message : error, context, alwaysLog);
    log_error_counter += 1;
  }
};

export const info = (message, context, alwaysLog) => {
  if (typeof message !== "string") {
    message = "Unknown info message";
  }
  if (typeof context !== "object") {
    context = {};
  }
  return event("info", message, context, alwaysLog);
};
